export enum QuickviewType {
  Cart = 'cart',
  Categories = 'categories',
  Menu = 'menu',
  Search = 'search',
  ShopFilter = 'shop-filter',
}
